<template>
  <div class="allFund">
    <div class="contentWrap1">
      <div class="topText">用户总资金结构图</div>
      <div class="divSize fund rColor">
        <p class="title">总资金</p>
        <p class="text1">{{ fundTotal | toThousands }}</p>
        <div class="line"></div>
        <div class="line1"></div>
        <div class="line3"></div>
        <div class="line4"></div>
        <div class="line5"></div>
        <div class="line7"></div>
        <div class="line8"></div>
        <div class="line9"></div>
        <div class="line11"></div>
        <div class="line111"></div>
        <div class="line112"></div>
        <div class="line113"></div>
        <div class="line211"></div>
        <div class="line212"></div>
        <div class="line213"></div>
        <div class="line21"></div>
        <div class="divSize ddFund gColor">
          <p class="title">订单系统</p>
          <p class="text1">{{ fundDd | toThousands }}</p>
        </div>
        <div class="divSize xhFund gColor">
          <p class="title">挂牌系统</p>
          <p class="text1">{{ fundGp | toThousands }}</p>
        </div>
        <div class="divSize ddFundKy bColor">
          <p class="title">可用资金</p>
          <p class="text1">{{ fundDdKy | toThousands }}</p>
        </div>
        <div class="divSize ddFundDj yColor">
          <p class="title">冻结资金</p>
          <p class="text1">{{ fundDdDj | toThousands }}</p>
        </div>
        <div class="divSize zjFund gColor">
          <p class="title">资金系统</p>
          <p class="text1">{{ fundZj | toThousands }}</p>
        </div>
        <div class="divSize zjFundKy bColor">
          <p class="title">可用资金</p>
          <p class="text1">{{ fundZjKy | toThousands }}</p>
        </div>
        <div class="divSize zjFundDj yColor">
          <p class="title">冻结资金</p>
          <p class="text1">{{ fundZjDj | toThousands }}</p>
        </div>
        <div class="divSize xhFundKy bColor">
          <p class="title">可用资金</p>
          <p class="text1">{{ fundGpKy | toThousands }}</p>
        </div>
        <div class="divSize xhFundDj yColor">
          <p class="title">冻结资金</p>
          <p class="text1">{{ fundGpDj | toThousands }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocolTrans*/
export default {
  data() {
    return {
      firmIds: [],
      fundTotal: null, // 总资金
      fundZj: null, // 资金系统
      fundZjKy: null, // 资金系统可用
      fundZjDj: null, // 资金系统冻结
      fundDd: null, // 订单系统
      fundDdKy: null, // 订单系统可用
      fundDdDj: null, // 订单系统冻结
      fundGp: null, // 挂牌系统
      fundGpKy: null, // 挂牌可用
      fundGpDj: null // 挂牌冻结
    }
  },
  mounted() {
    // this.getAllFund()
    this.getAllFirmId()
  },
  methods: {
    getAllFirmId() {
      const allFirmId = JSON.parse(localStorage.getItem('FirmIdList_w'))
      allFirmId.forEach(item => {
        if (item.marketId == 0 || item.marketId == 28 || item.marketId == 32) {
          this.firmIds.push(item.firmId)
        }
      })
      this.getAllFund()
    },
    // 查询所有市场的资金情况
    getAllFund() {
      protocolTrans.param_mineAsset.param.firmIds = this.firmIds
      http.postFront(protocolTrans.param_mineAsset).then(response => {
        if (response.data) {
          if (response.data && response.data.code == '0') {
            const dataList = response.data.value
            dataList.forEach(item => {
              if (item.marketId == 0) {
                this.fundZjKy = item.avilibleMargin // 资金系统可用
                this.fundZjDj = item.frozenFunds // 资金系统冻结
                this.fundZj = item.balance
              }
              if (item.marketId == 28) {
                this.fundDdKy = item.avilibleMargin
                this.fundDdDj = item.frozenFunds
                this.fundDd = item.balance
              }
              if (item.marketId == 32) {
                this.fundGpKy = item.avilibleMargin
                this.fundGpDj = item.frozenFunds
                this.fundGp = item.balance
              }
            })
            this.fundTotal = this.fundZj + this.fundDd + this.fundGp
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.allFund {
  position: relative;
  height: 800px;
  background: #141625 !important;
  //   top: 100px;
  .divSize {
    width: 192px;
    height: 86px;
    text-align: center;
    background-color: #333;
    font-size: 20px;
    .title {
      font-weight: 400;
      padding-top: 14px;
      color: rgba(255, 255, 255, 0.8);
    }
    .text1 {
      font-weight: 600;
      color: #ffffff;
    }
  }
  .rColor {
    background: #ef5557;
  }
  .gColor {
    background: #24df11;
  }
  .bColor {
    background: #1c7df6;
  }
  .yColor {
    background: #ff9705;
  }
  .contentWrap1 {
    position: absolute;
    // margin-top: 100px;
    left: 43%;
    margin: 0 auto;
    // margin-left: 800px;
    .topText {
      text-align: center;
      padding-top: 80px;
      padding-bottom: 40px;
      font-size: 24px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.8);
    }
    .fund {
      position: relative;
      margin-bottom: 530px;
      .line {
        position: absolute;
        width: 2px;
        height: 160px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 86px;
        left: 96px;
      }
      .line1 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 332px;
        left: 96px;
      }
      .line111 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -437px;
      }
      .line112 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -217px;
      }
      .line21 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 332px;
        left: 518px;
      }
      .line11 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 332px;
        left: -328px;
      }
      .line4 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -14px;
      }
      .line5 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: 206px;
      }
      .line3 {
        position: absolute;
        width: 220px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -14px;
      }
      .line113 {
        position: absolute;
        width: 220px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        left: -437px;
      }
      .line213 {
        position: absolute;
        width: 220px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        right: -436px;
      }
      .line211 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        right: -438px;
      }
      .line212 {
        position: absolute;
        width: 2px;
        height: 80px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 412px;
        right: -216px;
      }
      .line6 {
        position: absolute;
        width: 600px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: -289px;
      }
      .line7 {
        position: absolute;
        width: 2px;
        height: 88px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: -329px;
      }
      .zjFund {
        position: absolute;
        top: 246px;
        left: -420px;
      }
      .zjFundKy {
        position: absolute;
        top: 492px;
        left: -527px;
      }
      .zjFundDj {
        position: absolute;
        top: 492px;
        left: -317px;
      }
      .ddFund {
        position: absolute;
        top: 245px;
        left: 422px;
      }
      .ddFundKy {
        position: absolute;
        top: 492px;
        right: -320px;
      }
      .ddFundDj {
        position: absolute;
        top: 492px;
        right: -530px;
      }
      .line9 {
        position: absolute;
        width: 2px;
        height: 88px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: 519px;
      }
      .line8 {
        position: absolute;
        width: 846px;
        height: 2px;
        background-color: rgba(255, 255, 255, 0.6);
        top: 162px;
        left: -327px;
      }
      .xhFund {
        position: absolute;
        top: 246px;
      }
      .xhFundKy {
        position: absolute;
        top: 492px;
        left: -110px;
      }
      .xhFundDj {
        position: absolute;
        top: 492px;
        right: -110px;
      }
    }
  }
}
</style>
